// Gate the Quality Co-Pilot door (/portal/quality-copilot) to staff with the
// quality:copilot grant, the read-only quality:viewer grant (the Sigma team
// and the executives, kanban 808dabf6), OR any admin (mirrors the backend
// `require_copilot_user`, which lets admins through; admin role defaults do
// NOT include either scope). Others are sent to their default landing page.
// The admin sidebar's "Quality desk" entry (proposal 12) relies on the admin
// branch. What a viewer may DO inside is decided by the shell
// (utils/qualityViewer.ts isQualityViewer), not here.

import type React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import { getDefaultLandingPage } from '../../utils/landingPage';
import { canOpenQualityDoor } from '../../utils/qualityViewer';

export default function CopilotRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (!canOpenQualityDoor(user)) {
    return <Navigate to={user ? getDefaultLandingPage(user) : '/dashboard'} replace />;
  }
  return <>{children}</>;
}
